<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Sinteză proiect"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box flex space-between align-center">
                <div ref="scrollTo">
                    <h3 class="module-title">Sinteza proiectului tău. Te rugăm să acorzi atenție suplimentară câmpurilor marcate cu atenționari.</h3>
                    <p>Îți mulțumim pentru utilizarea aplicației <strong>POC</strong>Sketch</p>
                </div>
                <img src="@/assets/images/M3/M3Sketch/warning-sign.png" class="warning-sign">
            </div>
            <AsumariContent :allData="allData"></AsumariContent>
            <SintezaProiectBody :completePages="completePages" :max-budget="maxBudget" @addToProgress="$emit('addToProgress', $event)" @removeFromProgress="$emit('removeFromProgress', $event)"></SintezaProiectBody>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>
    </div>
</template>

<script>
    import SintezaProiectBody from '../components/sinteza-proiect/SintezaProiectBody'
    import AsumariContent from '../components/asumari/AsumariContent'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import { BIconChevronUp } from "bootstrap-vue";

    export default {
        components: {
            SintezaProiectBody,
            AsumariContent,
            SketchBreadcrumb,
            BIconChevronUp
        },
        props: {
            completePages: null,
        },
        data() {
            return {
            }
        },
        computed: {
            maxBudget() {
                return this.$store.getters['m3Sketch/maxBudget'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        mounted() {
        },
        methods: {
            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
        }
    }
</script>

<style scoped>
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 99999;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}
</style>
